import React from 'react';
import { MapPin, AlertCircle, Camera } from 'lucide-react';
import { Card } from '../ui/Card';
import { useLanguage } from '../../contexts/LanguageContext';
interface ReviewSubmitProps {
  formData: any;
}
export const ReviewSubmit: React.FC<ReviewSubmitProps> = ({
  formData
}) => {
  const {
    t
  } = useLanguage();
  return <div className="space-y-6" data-id="element-551">
      <div className="mb-8" data-id="element-552">
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-553">
          {t.reviewSubmit.title}
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-554">{t.reviewSubmit.subtitle}</p>
      </div>

      <Card className="p-8" data-id="element-555">
        <div className="space-y-8" data-id="element-556">
          {/* Room Selection */}
          <div className="border-l-4 border-navy pl-6" data-id="element-557">
            <div className="flex items-start gap-4" data-id="element-558">
              <MapPin className="w-8 h-8 text-navy flex-shrink-0 mt-1" data-id="element-559" />
              <div className="flex-1" data-id="element-560">
                <h3 className="text-xl font-semibold text-navy mb-2" data-id="element-561">
                  {t.reviewSubmit.sections.location}
                </h3>
                <p className="text-gray-700 text-lg" data-id="element-562">
                  {t.roomSelection.rooms[formData.room as keyof typeof t.roomSelection.rooms] || formData.room}
                </p>
              </div>
            </div>
          </div>

          {/* Problem Description */}
          <div className="border-l-4 border-teal-deep pl-6" data-id="element-563">
            <div className="flex items-start gap-4" data-id="element-564">
              <AlertCircle className="w-8 h-8 text-teal-deep flex-shrink-0 mt-1" data-id="element-565" />
              <div className="flex-1" data-id="element-566">
                <h3 className="text-xl font-semibold text-navy mb-2" data-id="element-567">
                  {t.reviewSubmit.sections.problem}
                </h3>
                <p className="text-gray-700 text-lg whitespace-pre-wrap" data-id="element-568">
                  {formData.description}
                </p>
              </div>
            </div>
          </div>

          {/* Photos */}
          {formData.photos && formData.photos.length > 0 && <div className="border-l-4 border-teal-deep pl-6" data-id="element-569">
              <div className="flex items-start gap-4" data-id="element-570">
                <Camera className="w-8 h-8 text-teal-deep flex-shrink-0 mt-1" data-id="element-571" />
                <div className="flex-1" data-id="element-572">
                  <h3 className="text-xl font-semibold text-navy mb-2" data-id="element-573">
                    {t.problemDescription.labels.photos}
                  </h3>
                  <div className="grid grid-cols-3 gap-4" data-id="element-574">
                    {formData.photos.map((photo: string, index: number) => <div key={index} className="relative" data-id="element-575">
                        <img src={photo} alt={`Evidence ${index + 1}`} className="w-full h-32 object-cover rounded-lg shadow-sm" data-id="element-576" />
                      </div>)}
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </Card>

      {/* Important Note */}
      <Card className="p-6 border border-gray-200" data-id="element-577">
        <div className="flex items-start gap-4" data-id="element-578">
          <AlertCircle className="w-6 h-6 text-gray-400 flex-shrink-0 mt-1" data-id="element-579" />
          <div data-id="element-580">
            <h4 className="font-semibold text-navy mb-2 text-lg" data-id="element-581">
              {t.reviewSubmit.note.title}
            </h4>
            <p className="text-gray-700 text-base" data-id="element-582">
              {t.reviewSubmit.note.text}
            </p>
          </div>
        </div>
      </Card>
    </div>;
};